import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
type Buyer = {
  name: string;
  city: string;
};
const buyers: Buyer[] = [{
  name: 'María G.',
  city: 'Madrid, España'
}, {
  name: 'Carlos R.',
  city: 'Bogotá, Colombia'
}, {
  name: 'Ana L.',
  city: 'Ciudad de México, México'
}, {
  name: 'Lucía F.',
  city: 'Buenos Aires, Argentina'
}, {
  name: 'José M.',
  city: 'Lima, Perú'
}, {
  name: 'Patricia S.',
  city: 'Santiago, Chile'
}, {
  name: 'Roberto D.',
  city: 'Guadalajara, México'
}, {
  name: 'Elena V.',
  city: 'Barcelona, España'
}, {
  name: 'Miguel A.',
  city: 'Quito, Ecuador'
}, {
  name: 'Sofía T.',
  city: 'Monterrey, México'
}, {
  name: 'Diego P.',
  city: 'Medellín, Colombia'
}, {
  name: 'Carmen N.',
  city: 'Valencia, España'
}];
const PRODUCT = 'Recetas Deliciosas para Hígados Sanos';
function randomBetween(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
export function PurchasePopup() {
  const [current, setCurrent] = useState<Buyer | null>(null);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    let nextTimeout: ReturnType<typeof setTimeout>;
    const showOne = () => {
      const buyer = buyers[randomBetween(0, buyers.length - 1)];
      setMinutesAgo(randomBetween(1, 14));
      setCurrent(buyer);
      // Visible for ~6s
      hideTimeout = setTimeout(() => {
        setCurrent(null);
        // Schedule next one in 25–40s
        nextTimeout = setTimeout(showOne, randomBetween(25000, 40000));
      }, 6000);
    };
    // First popup after a short delay
    const initialTimeout = setTimeout(showOne, 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearTimeout(nextTimeout);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[calc(100%-2rem)] sm:max-w-sm pointer-events-none" aria-live="polite" aria-atomic="true" data-id="element-155">
      <AnimatePresence data-id="element-156">
        {current && <motion.div key={current.name + minutesAgo} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 28
      }} className="pointer-events-auto bg-white rounded-2xl shadow-xl border border-gray-100 p-4 flex items-center gap-3" data-id="element-157">
            <div className="flex-shrink-0 w-11 h-11 bg-brand-primary/10 rounded-full flex items-center justify-center text-xl" data-id="element-158">
              🛒
            </div>
            <div className="flex-1 min-w-0 pr-4" data-id="element-159">
              <p className="text-sm font-bold text-gray-900 leading-tight" data-id="element-160">
                {current.name}{' '}
                <span className="font-normal text-gray-500" data-id="element-161">
                  · {current.city}
                </span>
              </p>
              <p className="text-sm text-gray-600 leading-tight mt-0.5" data-id="element-162">
                Acaba de comprar <span className="font-medium" data-id="element-163">{PRODUCT}</span>
              </p>
              <p className="text-xs text-brand-accent font-semibold mt-1 flex items-center gap-1" data-id="element-164">
                <CheckCircle2 className="w-3.5 h-3.5" data-id="element-165" />
                Compra verificada · hace {minutesAgo}{' '}
                {minutesAgo === 1 ? 'minuto' : 'minutos'}
              </p>
            </div>
            <button onClick={() => setCurrent(null)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-gray-300 hover:text-gray-500 transition-colors" data-id="element-166">
              <X className="w-4 h-4" data-id="element-167" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}